import PropTypes from 'prop-types';
import Ratings from 'components/Dealer/About/Ratings';
import Description from 'components/Dealer/About/Description';
import { screen } from 'components/styles/variables';

export default function About({ dealer, description }) {
  const {
    recommendedPercentage,
    averageOverallStars,
    totalReviews,
    averagePricingStars,
    averageServiceStars,
    averageHelpfulnessStars,
    averageResponsivenessStars,
  } = dealer;

  return (
    <div className="about-container">
      <div className="about-body">
        {totalReviews ? (
          <Ratings
            recommendedPercentage={recommendedPercentage}
            averageOverallStars={averageOverallStars}
            totalReviews={totalReviews}
            averagePricingStars={averagePricingStars}
            averageServiceStars={averageServiceStars}
            averageHelpfulnessStars={averageHelpfulnessStars}
            averageResponsivenessStars={averageResponsivenessStars}
          />
        ) : null}
        <Description content={description} />
      </div>
      <style jsx>{`
        .about-body {
          padding: 25px 15px 55px 15px;
        }

        @media (min-width: ${screen.smMin}) {
          .about-body {
            padding: 35px 0px 55px 0px;
          }
        }
      `}</style>
    </div>
  );
}

About.propTypes = {
  dealer: PropTypes.object.isRequired,
  description: PropTypes.string,
};
